import { useState } from 'react';
import { useWebhookErrors } from '@/hooks/useAdmin';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export const AdminWebhookErrorsPage = () => {
  const [date, setDate] = useState(() => new Date().toISOString().split('T')[0]);
  const { data: errors, isLoading } = useWebhookErrors(date);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div>
      <div
        className="flex flex-col sm:flex-row sm:items-center justify-between"
        style={{ marginBottom: 'var(--space-6)', gap: 'var(--space-3)' }}
      >
        <h1
          style={{
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          Webhook Errors
        </h1>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="admin-input"
          style={{ width: 'auto' }}
        />
      </div>

      {isLoading && (
        <div className="flex min-h-[40vh] items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      )}

      {!isLoading && (!errors || errors.length === 0) && (
        <p style={{ color: 'var(--text-tertiary)' }}>
          No webhook errors for {date}.
        </p>
      )}

      {errors && errors.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {errors.map((err) => (
            <div
              key={err.errorId}
              style={{
                borderRadius: 'var(--radius-lg)',
                border: `1px solid ${err.resolved ? 'var(--border-default)' : '#fecaca'}`,
                backgroundColor: err.resolved ? 'var(--bg-surface)' : '#fef2f2',
                padding: 'var(--space-4)',
              }}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)', color: 'var(--text-primary)' }}>
                    {err.eventType}
                  </p>
                  <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                    {new Date(err.timestamp).toLocaleTimeString()}
                    {err.stripeEventId && ` | ${err.stripeEventId}`}
                  </p>
                </div>
                <button
                  onClick={() => setExpandedId(expandedId === err.errorId ? null : err.errorId)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--text-accent)',
                    padding: 'var(--space-2) var(--space-3)',
                    minHeight: '36px',
                  }}
                >
                  {expandedId === err.errorId ? 'Hide' : 'Details'}
                </button>
              </div>

              <p style={{ marginTop: 'var(--space-2)', fontSize: 'var(--text-sm)', color: '#991b1b' }}>
                {err.errorMessage}
              </p>

              {expandedId === err.errorId && (
                <pre
                  style={{
                    marginTop: 'var(--space-3)',
                    padding: 'var(--space-3)',
                    borderRadius: 'var(--radius-md)',
                    backgroundColor: 'var(--bg-surface-sunken)',
                    fontSize: 'var(--text-xs)',
                    color: 'var(--text-secondary)',
                    overflowX: 'auto',
                    maxHeight: '200px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {err.rawPayload}
                </pre>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
